export enum PTextEditorButtons {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  LIST_OL = 'list-ol',
  LIST_UL = 'list-ul',
  LINK = 'link',
}
